module.exports = __webpack_public_path__ + "media/images/icon__matchdayNavigation--pagination--arrow-8b944eedcd757abc9c9ac18588c5e246.png";